import React from 'react'
import './CSS/Product.css'
import { Link } from 'react-router-dom'
import { MdOutlineStar } from "react-icons/md";
import product_image from '../../src/Assets/product.png'
import brilliant_satin from '../../src/Assets/platinum/brilliant-satin.png'
import acry_premier from '../../src/Assets/platinum/acry-premier.png'
import brilliant_soft from '../../src/Assets/platinum/brilliant-soft.png'
import classic_matt from '../../src/Assets/platinum/classic-matt.png'
import acrylique_premier from '../../src/Assets/platinum/acrylique-premier.png'
import lux_emulsion from '../../src/Assets/platinum/lux-emulsion.png'
import protect_seal from '../../src/Assets/platinum/protect-seal.png'
import premium_silk from '../../src/Assets/platinum/premium-silk.png'
import platin_matt from '../../src/Assets/platinum/platin-matt.png'
import { FaPaintRoller } from "react-icons/fa";
import { LuPaintBucket } from "react-icons/lu";
import { PiPaintBrushBroadBold } from "react-icons/pi";
import { MdInvertColors } from "react-icons/md";
import maunacil_emulsion from '../../src/Assets/Maunacil/maunacil-emulsion.png'
import maunacil_oil from '../../src/Assets/Maunacil/luminate-oil-paint.png'
import maunacil_globe_bond from '../../src/Assets/Maunacil/luminate-globe-bond.png'
import maunacil_satin from '../../src/Assets/Maunacil/satin-paint.png'
import maunacil_matte from '../../src/Assets/Maunacil/matte-paint.png'
import maunacil_e_matte from '../../src/Assets/Maunacil/e-matte.png'
import maunacil_stucco from '../../src/Assets/Maunacil/stucco-paint.png'
import maunacil_screeding_putty from '../../src/Assets/Maunacil/screeding-putty.png'
import maunacil_texcoat from '../../src/Assets/Maunacil/luminate-texcoat.png'
import maunacil_screeding_paint from '../../src/Assets/Maunacil/screeding-paint.png'
import maunacil_sand_towel from '../../src/Assets/Maunacil/sand-towel.png'
import maunacil_stucroll from '../../src/Assets/Maunacil/stucroll.png'
import maunacil_silk_matte from '../../src/Assets/Maunacil/silk-mate.png'



const Products = () => {
  return (
    <div className='product'>
         <div className='product-container'>
              <div className='image-container'>
                  <img width={1430} height={400} src={product_image} alt='products banner' />
                  <div className='image-overlay'>
                      <p>Maunacil Decorative Products Showcase</p>
                  </div>
              </div>

              <div className='maunacil-product-container'>
                  <div className='maunacil-product-headline'>Maunacil Luminate Products Line</div>

                  <div className='product-card-container'>

                      <div className='product-card one'>
                          <div className='maunacil-product-card-left one'>
                              <img width={110} src={maunacil_emulsion} alt='emulsion paint' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Emulsion paint</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    is a water based paint (matte in nature) 
                                    used in interior and exterior decoration 
                                    depending on the quality. 
                                    lt has an average coverage of
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                   <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <FaPaintRoller size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                        <LuPaintBucket size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card two'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_oil} alt='oil paint' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>oil paint</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate oil paint is oil based paint with glossy 
                                    appearance used mainly in coating metals. 
                                    Its coverage is about
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card three'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_globe_bond} alt='Globe bond' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Globe bond</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate globe bond is a water based adhesion 
                                    whitish in color, also known as wood glue.
                                    Our globe bond is multi- purpose; you can use 
                                    it for woodwork, binding books, on plastic 
                                    tiles and for Screeding. You can also use 
                                    it on your clothes instead of starch to strengthen them
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card four'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_satin} alt='Satin paint' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Satin paint</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate satin is a glossy water based paint 
                                    which can be applied mainly after Screeding the 
                                    wall (substrate). You can wash it with water. 
                                    It is locally called rubber paint. Satin is mainly 
                                    for interior decoration. Coverage is about 13 -18m2 per
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card five'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_matte} alt='Matte paint' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Matte paint</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate matte, as the name implies is not a glossy 
                                    paint but a high quality water based paint much more 
                                    higher than emulsion, used for both exterior and 
                                    interior decoration. Coverage =13 -18m2 per
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card six'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_e_matte } alt='E- matte' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'> E- matte </h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate e-matte is a higher quality emulsion for 
                                    exterior and interior decoration. Coverage = 10 -15m2 per .
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card seven'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_stucco} alt='Stucco' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Stucco</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate stucco is a mirror paint as locally called with 
                                    its glassy texture. It is mainly applied with screeding pan 
                                    (stucco pan) after screeding the substrate, which must 
                                    be free from oil, grease etc . coverage =4.5 - 5.5m2 per kg
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card eight'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_screeding_putty} alt='Screeding putty' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Screeding putty</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate screeding putty is a water based coating used 
                                    in Screeding the wall to get a smooth or leveled 
                                    substrate for painting. coverage =...
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card nine'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_texcoat} alt='Texcoate' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'> Texcoate</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate texcoat is a textured paint produced with marble 
                                    dust used mainly for exterior decoration. 
                                    Its coverage is about 18 - 20m2 per 30kg.
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                       <div className='product-card ten'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_screeding_paint} alt='Screeding paint' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'> Screeding paint</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate Screeding paint is a water based paint 
                                    meant for Screeding and POP work 
                                    (in mixing it with white cement and bond).
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card eleven'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_sand_towel} alt='Sand trowel' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Sand trowel</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate Sand trowel is gotten from marble dust 
                                    of different colors used mainly for exterior 
                                    design. Coverage =5 - 8m2 per 25kg.
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card twelve'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_silk_matte} alt='Silk matte' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Silk matte</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate Silk matte is a semi-silk paint; a higher 
                                    level of matte that is washable for both exterior 
                                    and interior decoration. Coverage
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                       <div className='product-card thirteen'>
                          <div className='maunacil-product-card-left'>
                              <img width={110} src={maunacil_stucroll} alt='Stucroll' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Stucroll</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Luminate Stucroll is a semi stucco paint that can be 
                                    rolled (i.e applied with roller) or used as first 
                                    coating while applying stucco. It has that mirroic 
                                    nature of stucco. Coverage
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                  </div>
              </div>

              <div className='platinum-product-container'>
                  <div className='product-headline'>Platinum Products Line</div>

                  <div className='product-card-container'>

                      <div className='product-card one'>
                          <div className='product-card-left'>
                              <img width={110} src={brilliant_satin} alt='Brilliant Satin' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Brilliant Satin</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 400 sq ft per gallon
                                    Finish: Matte
                                    Durability: 10 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                   <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <FaPaintRoller size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                        <LuPaintBucket size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card two'>
                          <div className='product-card-left'>
                              <img width={110} src={acry_premier} alt='Acry Premier' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Acry Premier</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card three'>
                          <div className='product-card-left'>
                              <img width={110} src={brilliant_soft} alt='Brilliant Soft' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Brilliant Soft</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card four'>
                          <div className='product-card-left'>
                              <img width={110} src={classic_matt} alt='Classic Matt' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Classic Matt</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card five'>
                          <div className='product-card-left'>
                              <img width={110} src={acrylique_premier} alt='Acrylic Premier' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Acrylic Premier</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card six'>
                          <div className='product-card-left'>
                              <img width={110} src={lux_emulsion} alt='Lux Emulsion' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Lux Emulsion</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card seven'>
                          <div className='product-card-left'>
                              <img width={110} src={protect_seal} alt='Protect Seal' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Protect Seal</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card eight'>
                          <div className='product-card-left'>
                              <img width={110} src={premium_silk} alt='Premium Silk' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Premium Silk</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                      <div className='product-card nine'>
                          <div className='product-card-left'>
                              <img width={110} src={platin_matt} alt='Platin Matt' />
                          </div>
                          <div className='product-card-right'>
                                <h2 className='product-title'>Platin Matt</h2>
                                <p className='product-desc'>
                                    <h3>Specification: </h3>
                                    Coverage: 350 sq ft per gallon
                                    Finish: Flat
                                    Durability: 5 years
                                    Application: Brush, Roller, or Spray
                                </p>
                                <div className='horizontal-line'></div>
                                <div className='product-rating-and-btn'>
                                    <div className='product-rating'>
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                        <MdOutlineStar />
                                    </div>
                                    <Link style={{ textDecoration: 'none'}} to={'/contact'}><button>Buy Now</button></Link>
                                </div>

                                <div className='accessory'>
                                    <div className='accessory-item'>
                                        <div><FaPaintRoller size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <div><LuPaintBucket size={15} className='middle-feature-text-icon' /></div>
                                    </div>

                                    <div className='accessory-item'>
                                        <PiPaintBrushBroadBold  size={15} />
                                    </div>

                                    <div className='accessory-item'>
                                       <MdInvertColors size={15}  />
                                    </div>
                                    
                                </div>
                          </div>
                      </div>

                  </div>

              </div>
             
         </div>
    </div>     
)
}
export default Products
